/* TOPSAFE — página de producto (Fase 2).
   - Marca tallas agotadas en el selector y muestra "Avísame cuando llegue".
   - Actualiza el mensaje de WhatsApp con la talla y el SKU elegidos.
   - "Pedir precio empresa" abre el formulario de Storeify si existe.
   - "Completa tu equipo": complementarios de Search & Discovery con respaldo.
   - Pestañas del producto.
   - Despacho o retiro (atributo "Entrega preferida") y "Comprar ahora" directo al pago.
   Cargado solo en la plantilla de producto (sections/main-product.liquid). */
(function () {
  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }

  /* ---------- Variantes del producto principal ---------- */
  var picker = document.querySelector('variant-radios[data-section], variant-selects[data-section]');
  var sectionId = picker ? picker.dataset.section : null;
  var variants = [];
  if (picker) {
    try { variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent); } catch (e) { variants = []; }
  }
  var mainForm = sectionId ? document.getElementById('product-form-' + sectionId) : null;
  var mainIdInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;

  /* Variante según las opciones marcadas (null si la combinación no existe). */
  function currentVariant() {
    if (!variants.length) return null;
    var sel = selectedOptions();
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === sel[i]; });
    }) || null;
  }

  function selectedOptions() {
    if (!picker) return [];
    if (picker.tagName === 'VARIANT-SELECTS') {
      return Array.prototype.map.call(picker.querySelectorAll('select'), function (s) { return s.value; });
    }
    return Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
  }

  /* Tallas agotadas: tachadas pero seleccionables (así aparece el aviso). */
  function markSoldOut() {
    if (!picker || picker.tagName !== 'VARIANT-RADIOS' || !variants.length) return;
    var sel = selectedOptions();
    picker.querySelectorAll('fieldset').forEach(function (fs, idx) {
      var inputs = fs.querySelectorAll('input[type="radio"]');
      if (inputs.length < 2) return; /* opción con un solo valor (ej. un color): no se marca */
      inputs.forEach(function (input) {
        var wanted = sel.slice();
        wanted[idx] = input.value;
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return wanted[i] == null || opt === wanted[i]; });
        });
        var label = fs.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        var soldOut = !match || !match.available;
        label.classList.toggle('tsc-oos', soldOut);
        if (soldOut) label.setAttribute('title', 'Agotado'); else label.removeAttribute('title');
      });
    });
  }

  /* ---------- Avísame cuando llegue ---------- */
  var notify = document.querySelector('tsc-pdp-notify');
  function syncNotify(v) {
    if (!notify) return;
    var show = !!(v && !v.available);
    notify.hidden = !show;
    if (!v) return;
    var vIn = notify.querySelector('[data-notify-variant]');
    var sIn = notify.querySelector('[data-notify-sku]');
    var size = notify.querySelector('[data-notify-size]');
    if (vIn) vIn.value = v.title || '';
    if (sIn) sIn.value = v.sku || '';
    if (size) size.textContent = v.title && v.title !== 'Default Title' ? 'la talla ' + v.title : 'el producto';
  }
  if (notify) {
    var nForm = notify.querySelector('form');
    if (nForm) {
      nForm.addEventListener('submit', function (evt) {
        if (!window.fetch || !window.FormData) return;
        evt.preventDefault();
        var btn = nForm.querySelector('button[type="submit"]');
        var ok = nForm.querySelector('.tsc-notify__ok');
        var err = nForm.querySelector('.tsc-notify__err');
        if (btn) btn.disabled = true;
        if (err) err.hidden = true;
        fetch(nForm.action, { method: 'POST', body: new FormData(nForm), credentials: 'same-origin' })
          .then(function (r) {
            /* Shopify puede pedir captcha: en ese caso se envía normal (recarga). */
            if (r.url && r.url.indexOf('/challenge') !== -1) { HTMLFormElement.prototype.submit.call(nForm); return; }
            if (!r.ok) throw new Error(r.status);
            nForm.querySelectorAll('.tsc-notify__title, .tsc-notify__row').forEach(function (el) { el.hidden = true; });
            if (ok) ok.hidden = false;
            track('tsc_back_in_stock_request', { variant_id: (currentVariant() || {}).id });
          })
          .catch(function () {
            if (err) err.hidden = false;
            if (btn) btn.disabled = false;
          });
      });
    }
  }

  /* ---------- WhatsApp con talla y SKU ---------- */
  var wa = document.querySelector('[data-tsc-wa]');
  function syncWhatsapp(v) {
    if (!wa) return;
    var parts = ['Hola, quiero consultar por este producto: ' + wa.dataset.title];
    if (v && wa.dataset.single !== 'true') parts.push('Talla/variante: ' + v.title);
    if (v && v.sku) parts.push('SKU: ' + v.sku);
    parts.push(wa.dataset.url + (v ? '?variant=' + v.id : ''));
    wa.href = 'https://wa.me/' + wa.dataset.phone + '?text=' + encodeURIComponent(parts.join(' · '));
  }
  if (wa) wa.addEventListener('click', function () { track('tsc_pdp_whatsapp_click'); });

  function onVariantChange() {
    var v = currentVariant();
    markSoldOut();
    syncNotify(v);
    syncWhatsapp(v);
  }
  if (mainIdInput) mainIdInput.addEventListener('change', onVariantChange);
  if (picker) picker.addEventListener('change', function () { setTimeout(onVariantChange, 0); });
  onVariantChange();

  /* ---------- Precio empresa → /pages/venta-empresa (el enlace navega solo) ---------- */
  document.addEventListener('click', function (evt) {
    if (evt.target.closest('[data-tsc-quote]')) track('tsc_pdp_b2b_click');
  });

  /* ---------- Completa tu equipo ---------- */
  var bundle = document.querySelector('tsc-pdp-bundle');
  if (bundle && sectionId && window.fetch) {
    var loadRecs = function () {
      fetch(bundle.dataset.url + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var rec = doc.querySelector('[data-tsc-bundle-rec]');
          if (!rec || !rec.querySelector('.tsc-bundle__item')) return;
          var list = bundle.querySelector('[data-tsc-bundle-list]');
          list.innerHTML = rec.innerHTML;
          bundle.hidden = false;
          bundle.dataset.source = 'complementary';
        })
        .catch(function () {});
    };
    if (bundle.hasAttribute('data-fixed')) {
      bundle.dataset.source = 'fixed'; /* lista elegida en product.json: no se reemplaza */
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        loadRecs();
      }, { rootMargin: '400px 0px' });
      io.observe(bundle.hidden ? (bundle.parentElement || bundle) : bundle);
    } else {
      loadRecs();
    }
    bundle.addEventListener('submit', function () {
      track('tsc_pdp_bundle_add', { source: bundle.dataset.source || 'fallback' });
    }, true);
  }

  /* ---------- Descripción recortada ---------- */
  function clampDesc(root) {
    root.querySelectorAll('[data-tsc-desc]').forEach(function (box) {
      if (box.dataset.ready) return;
      var body = box.querySelector('.tsc-desc__body');
      var more = box.querySelector('.tsc-desc__more');
      if (!body || !more || body.offsetParent === null) return; /* pestaña oculta: se mide al abrirla */
      box.dataset.ready = '1';
      if (body.scrollHeight <= 360) return;
      box.classList.add('is-clamped');
      more.hidden = false;
      var closedLabel = more.textContent;
      more.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? more.dataset.labelOpen : closedLabel;
        if (!open) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        track('tsc_pdp_desc_toggle', { open: open });
      });
    });
  }

  /* ---------- Descargas (app Easify): enlace a la ficha desde la pestaña ---------- */
  var pdf = document.querySelector('.tigren-product-attachments a.tigren-linkAttachment');
  if (pdf) {
    document.querySelectorAll('.tsc-specs__note').forEach(function (note) {
      note.innerHTML = '';
      var a = document.createElement('a');
      a.href = pdf.href; a.target = '_blank'; a.rel = 'noopener';
      a.textContent = 'Descargar ficha técnica del fabricante (PDF)';
      note.appendChild(a);
    });
    document.querySelectorAll('.tigren-product-attachments a').forEach(function (a) {
      a.addEventListener('click', function () { track('tsc_pdp_pdf_download'); });
    });
  }

  /* ---------- Pestañas ---------- */
  document.querySelectorAll('tsc-pdp-tabs').forEach(function (tabs) {
    var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
    if (!buttons.length) return;
    function activate(btn, focus) {
      buttons.forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) btn.focus();
      /* la pestaña elegida queda entera a la vista si la fila tiene scroll */
      var nav = btn.parentElement;
      if (nav && nav.scrollWidth > nav.clientWidth) {
        var left = btn.offsetLeft - nav.offsetLeft;
        if (left < nav.scrollLeft || left + btn.offsetWidth > nav.scrollLeft + nav.clientWidth) {
          nav.scrollTo({ left: Math.max(0, left - 16), behavior: 'smooth' });
        }
      }
      clampDesc(tabs);
    }
    buttons.forEach(function (b, i) {
      b.addEventListener('click', function () {
        activate(b, false);
        track('tsc_pdp_tab', { tab: b.dataset.tab });
      });
      b.addEventListener('keydown', function (evt) {
        var next = null;
        if (evt.key === 'ArrowRight') next = buttons[(i + 1) % buttons.length];
        else if (evt.key === 'ArrowLeft') next = buttons[(i - 1 + buttons.length) % buttons.length];
        else if (evt.key === 'Home') next = buttons[0];
        else if (evt.key === 'End') next = buttons[buttons.length - 1];
        if (next) { evt.preventDefault(); activate(next, true); }
      });
    });
    tabs.classList.add('is-ready');
    activate(buttons[0], false);
  });

  /* ---------- Despacho o retiro (tsc-pdp-delivery) ---------- */
  var DLV_KEY = 'tscDelivery';
  var dlv = document.querySelector('tsc-pdp-delivery');
  function dlvChoice() {
    var c = dlv && dlv.querySelector('input[name="tsc-delivery"]:checked');
    return c ? c.value : '';
  }
  function saveChoice(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Entrega preferida': value } })
    }).catch(function () {});
  }
  if (dlv) {
    var radios = Array.prototype.slice.call(dlv.querySelectorAll('input[name="tsc-delivery"]'));
    var showPanel = function () {
      var v = dlvChoice();
      dlv.querySelectorAll('[data-dlv-panel]').forEach(function (p) { p.hidden = p.dataset.dlvPanel !== v; });
    };
    var stored = null;
    try { stored = sessionStorage.getItem(DLV_KEY); } catch (e) {}
    radios.forEach(function (r) {
      if (stored && r.value === stored) r.checked = true;
      r.addEventListener('change', function () {
        showPanel();
        try { sessionStorage.setItem(DLV_KEY, r.value); } catch (e) {}
        saveChoice(r.value);
        track('tsc_pdp_delivery', { option: r.value });
      });
    });
    showPanel();
    /* al agregar al carro desde la ficha, el pedido lleva la entrega elegida */
    if (mainForm) mainForm.addEventListener('submit', function () { saveChoice(dlvChoice()); });
  }

  /* ---------- Comprar ahora: agrega y va directo al pago ---------- */
  document.querySelectorAll('[data-tsc-buynow]').forEach(function (btn) {
    var form = document.getElementById(btn.dataset.form);
    if (!form) return;
    var addBtn = form.querySelector('[name="add"]');
    /* habilitado igual que "Agregar al carro" (el theme lo cambia al elegir talla) */
    if (addBtn) {
      var sync = function () { btn.disabled = addBtn.disabled || addBtn.hasAttribute('aria-disabled'); };
      new MutationObserver(sync).observe(addBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      sync();
    }
    var wrap = form.closest('product-form');
    var errBox = wrap && wrap.querySelector('.product-form__error-message-wrapper');
    btn.addEventListener('click', function () {
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = document.getElementById(btn.dataset.qty);
      var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
      if (!idInput || !idInput.value) return;
      btn.disabled = true; btn.classList.add('is-loading');
      if (errBox) errBox.hidden = true;
      track('tsc_pdp_buy_now', { variant: idInput.value, quantity: qty, delivery: dlvChoice() });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: qty }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'No se pudo agregar');
          var choice = dlvChoice();
          return (choice ? saveChoice(choice) : Promise.resolve()).then(function () { window.location.href = '/checkout'; });
        })
        .catch(function (e) {
          btn.disabled = false; btn.classList.remove('is-loading');
          if (errBox) {
            errBox.hidden = false;
            var msg = errBox.querySelector('.product-form__error-message');
            if (msg) msg.textContent = e.message;
          }
        });
    });
  });
})();
